/* eslint-disable */
import axios from "axios";
import decryptData from "@/store/auth/decryptData";

export default {
  namespaced: true,
  state: () => ({
    departments: [],
    departmentsLoaded: false
  }),
  mutations: {
    SET_DEPARTMENTS(state, roles) {
      state.departments = roles;
      state.departmentsLoaded = true;
    }
  },
  actions: {
    async fetchDepartments({ commit, state }) {
      if (!state.departmentsLoaded) {
        const res = await axios.get("departments");
        const data = decryptData(res.data.payload).data.departments;
        const formatted = data.map(item => ({
          value: item.id,
          text: item.title
        }));
        commit("SET_DEPARTMENTS", [...formatted]);
      }
    }
  },
  getters: {
    departments: state => state.departments,
    departmentsLoaded: state => state.departmentsLoaded
  }
};
